"use client";

import { Switch } from "@headlessui/react";
import clsx from "clsx";
import { useState } from "react";

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const SwitchControl: React.FC<SwitchProps> = ({ checked, disabled, onChange }) => {
  const [enabled, setEnabled] = useState(checked);

  const onValueChanged = (val: any) => {
    setEnabled(val);
    onChange(val);
  };

  return (
    <Switch
      checked={enabled}
      disabled={disabled}
      onChange={onValueChanged}
      className={clsx("group inline-flex h-6 w-11 items-center rounded-full bg-gray-200 transition data-[checked]:bg-[#3C3C3B]", disabled && "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50")}
    >
      <span className="size-4 translate-x-1 rounded-full bg-white transition group-data-[checked]:translate-x-6" />
    </Switch>
  );
};

export default SwitchControl;
